/**
 * « Générer », côté élève : le même écran que celui du parent (`ui/Generer`),
 * avec les appels `/me/…` et des phrases tutoyées.
 *
 * Après l'ajout, la copie des cahiers de l'élève est oubliée — le compte des
 * exercices déjà faits vient de changer — et l'écran mène à la feuille en
 * cours, où l'élève voit ce qu'il vient d'ajouter.
 */

import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { call } from "@/api/client";
import { MON_ENTRAINEMENT } from "@/child/monEntrainement";
import { oublierMesOuvrages } from "@/ui/enCache";
import { Generer, type AppelsDeGeneration } from "@/ui/Generer";

export function MonGenererScreen() {
  const navigate = useNavigate();

  // Stable d'un rendu à l'autre : `Generer` relit la proposition quand
  // l'objet change.
  const appels = useMemo<AppelsDeGeneration>(
    () => ({
      proposer: (corps) => call("proposerMonEntrainement", { body: corps }),
      tirer: (corps) => call("tirerMonEntrainement", { body: corps }),
      ajouter: async (exerciseIds) => {
        await call("genererMonEntrainement", { body: { exercise_ids: exerciseIds } });
      },
    }),
    [],
  );

  return (
    <Generer
      pour="eleve"
      appels={appels}
      apresAjout={() => {
        oublierMesOuvrages();
        navigate(MON_ENTRAINEMENT);
      }}
    />
  );
}
